import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import LoadMoreSpinner from "~/components/LoadMoreSpinner";
export const useGallerySectionFooter = (param)=>{
    let { loadMore, isLoading, containerWidth, hasMore } = param;
    const loaderBox = useMemo(()=>hasMore || isLoading ? {
            aspectRatio: 0,
            left: 0,
            top: 0,
            width: containerWidth,
            height: 104
        } : null, [
        containerWidth,
        hasMore,
        isLoading
    ]);
    const renderLoader = useCallback((_, isVisible)=>{
        return loadMore ? /*#__PURE__*/ _jsx(LoadMoreSpinner, {
            isVisible: isVisible,
            isLoading: isLoading,
            loadMore: loadMore
        }, "loader") : null;
    }, [
        isLoading,
        loadMore
    ]);
    if (!loaderBox) {
        return;
    }
    return {
        box: loaderBox,
        render: renderLoader
    };
};
